import { Component, input } from '@angular/core';

/**
 * Vertical rail of Verlauf entries.
 *
 * A layout wrapper on purpose: the caller keeps the `@for` so it can project
 * per-entry content — inline tags, the «…» menu, a note's body — into each
 * `lp-verlauf-timeline-entry`, and tells the last one that it is last so the
 * rail stops there.
 */
@Component({
  selector: 'lp-verlauf-timeline',
  template: `
    @if (leadingConnector()) {
      <span class="lp-verlauf-timeline__leading-connector" aria-hidden="true"></span>
    }
    <ng-content />
  `,
  styleUrl: './verlauf-timeline.component.scss',
  host: { class: 'lp-verlauf-timeline' },
})
export class VerlaufTimelineComponent {
  /**
   * Starts the rail above the first entry, for a caller that puts something of
   * its own — a note composer — at the top of the same thread.
   */
  public readonly leadingConnector = input<boolean>(false);
}
